import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import P from '@deliveroo/consumer-component-library/components/P';
import { FEEDBACK_TEXT } from '../../containers/OrderHelpTemplateContainer/templateTypes';

import ModalFooter from '../ModalFooter';
import OrderHelpFeedbackText from '../OrderHelpFeedbackText';

import i18n from '../../utils/i18n';

/**
 * A generic dynamic actions template with a singular text input for feedback.
 */
function OrderHelpTemplateFeedbackText({
  iframe,
  data: { buttonText, placeholderText },
  actionId,
  hideFooterPrevious,
  requestInteraction,
  finishInteraction,
}) {
  return (
    <Fragment>
      <P isBold spacing={`0 ${iframe ? 'x-large' : 'medium'} medium`}>
        {placeholderText}
      </P>

      <OrderHelpFeedbackText
        iframe={iframe}
        buttonText={buttonText}
        setFeedbackDescription={(feedbackValue) => {
          requestInteraction({
            parentActionId: actionId,
            parentActionTemplate: FEEDBACK_TEXT,
            templateData: {
              description: feedbackValue,
            },
          });
        }}
      />

      <ModalFooter
        modal={iframe}
        onSubmit={finishInteraction}
        cta={i18n.gettext('Done')}
        hidePrevious={hideFooterPrevious}
      />
    </Fragment>
  );
}

OrderHelpTemplateFeedbackText.propTypes = {
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * Which help screen the template is currently on.
   */
  actionId: PropTypes.string.isRequired,
  /**
   * Template data to fill out the generic template.
   */
  data: PropTypes.shape({
    buttonText: PropTypes.string.isRequired,
    placeholderText: PropTypes.string.isRequired,
  }),
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The dispatch action that will be triggered onClick for each OrderHelpActionRows.
   * This will be used to update the dynamic action and grab the next self help page
   */
  requestInteraction: PropTypes.func.isRequired,
  /**
   * The action that will be triggered when finishing the interaction.
   */
  finishInteraction: PropTypes.func.isRequired,
};

OrderHelpTemplateFeedbackText.defaultProps = {
  data: {},
  hideFooterPrevious: true,
};

export default OrderHelpTemplateFeedbackText;
